/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

const Alpha = (color = "#000000", alphaNumber = 0) => {
  if (
    typeof color === "string" &&
    color.length === 7 &&
    typeof alphaNumber === "number" &&
    (alphaNumber >= 0 || alphaNumber <= 1)
  ) {
    const hexArr = [color.substr(1, 2), color.substr(3, 2), color.substr(5, 2)];
    const alphaArr = [
      parseInt(hexArr[0], 16),
      parseInt(hexArr[1], 16),
      parseInt(hexArr[2], 16),
    ];

    return `rgba(${alphaArr.join(",")}, ${alphaNumber})`;
  }

  return "transparent";
};

const Colors = {
  PRIMARY1: "#9e1e24",
  PRIMARY: "#FFFFFF",
  SECONDARY1: "#9e1e24",
  SECONDARY: "#c6c6c6",
  TERTIARY: "#9e1e24",
  GRAY: [
    "#666666",
    "#888888",
    "#A3A3A3",
    "#C0C0C0",
    "#E0E0E0",
    "#F5F5F5",
    "#53565A",
    "#2C2A28",
    "#898887",
    "#AEAEADB8",
    "#F2F2F2",
    "#E8E8E8",
    "#706F6F",
    "C6C6C6"
  ],
  
  DANGER: "#E73134",
  WHITE: "#FFFFFF",
  BLACK: "#1D1D1B",
  RED: "#D60D38",
  PINK: "#E73C84",
  GREEN: "#005336",
  PURPLE: "#631FC85",
  YELLOW: "#FCC800",
  DARK_GREEN: "#0005336",
  Alpha,
};

export default Colors;
